import React from "react";
import { Modal, ModalProps } from "react-bootstrap";

export declare type BSModalDefaultProps = {
  isVisible: boolean;
  onClose?: () => void;
};

type BSModalProps = BSModalDefaultProps & {
  hideHeader?: boolean;
  fullHeight?: boolean;
  title?: string;
  dialogClassName?: string;
  children?: React.ReactNode;
  modalStyle?: React.CSSProperties;
  modalBodyClassName?: string;
  className?: string;
  modalHeaderClassName?: string | undefined;
  size?: "sm" | "lg" | "xl";
  modalProps?: ModalProps;
  onHide?: () => void;
  closeButton?: boolean;
  scrollableFalse?: boolean;
};

const BSModal = ({
  isVisible = false,
  onClose,
  title,
  size,
  modalBodyClassName,
  dialogClassName,
  className,
  scrollableFalse,
  modalStyle,
  modalHeaderClassName,
  modalProps,
  fullHeight = false,
  hideHeader,
  onHide,
  closeButton = true,
  ...props
}: BSModalProps) => {
  return (
    <Modal
      show={isVisible}
      onHide={onHide ?? onClose}
      size={size}
      dialogClassName={dialogClassName ?? ""}
      className={`poppins ${className ?? ""}`}
      contentClassName={fullHeight ? "h-100" : ""}
      style={modalStyle}
      scrollable={scrollableFalse ? false : true}
      {...modalProps}
    >
      {!hideHeader && (
        <Modal.Header
          closeVariant="white"
          closeButton={closeButton}
          className={modalHeaderClassName}
        >
          {title && <Modal.Title>{title}</Modal.Title>}
        </Modal.Header>
      )}
      <Modal.Body className={modalBodyClassName}>{props.children}</Modal.Body>
    </Modal>
  );
};

export default BSModal;
